import globalLess from '@/global.less'
import Button from '@/shared/Button'
import ArrowDropDown from '@mui/icons-material/ArrowDropDown'
import ArrowDropUp from '@mui/icons-material/ArrowDropUp'
import Close from '@mui/icons-material/Close'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Chip from '@mui/material/Chip'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import { alpha } from '@mui/material/styles'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

const LabelSelectList = ({
  idKey,
  nameKey,
  useCountKey = 'useCount',
  page,
  onPageChange,
  paging,
  options = [],
  selected,
  onSelect,
  onDelete,
  isFullWidth = false,
  hideEdit = false,
}) => {
  const { t } = useTranslation()
  const [isEdit, setIsEdit] = useState(false)
  const { last } = paging
  const ChipsList = () => {
    let curStartIndex = 0
    const rows = []

    while (curStartIndex < options.length) {
      const chips = []

      for (let index = curStartIndex; index < curStartIndex + 5; index += 1) {
        if (index < options.length) {
          const opt = options[index]

          const id = opt[idKey]
          const name = opt[nameKey]
          const useCount = opt[useCountKey]
          const { canDelete = true } = opt

          const isSelected = selected === id

          chips.push(
            <Box key={`chip_item_${chips.length}`} flex={1} sx={{ overflow: 'hidden' }}>
              <Tooltip title={name} placement="top-end">
                <Chip
                  variant={isSelected && !isEdit ? 'filled' : 'outlined'}
                  color={'secondary_80'}
                  label={
                    <Stack direction="row" sx={{ maxWidth: '100%' }} spacing={1}>
                      <Box sx={{ flex: 1, overflowX: 'hidden', textOverflow: 'ellipsis' }}>
                        {name}
                      </Box>
                      <Box>{`(${useCount})`}</Box>
                    </Stack>
                  }
                  onClick={
                    isEdit
                      ? null
                      : () => {
                          onSelect?.(id)
                        }
                  }
                  onDelete={
                    isEdit && canDelete
                      ? () => {
                          onDelete?.(opt)
                        }
                      : null
                  }
                  sx={{
                    width: '100%',
                    maxWidth: '100%',
                    border: 'none',
                    justifyContent: 'flex-start',
                  }}
                  deleteIcon={
                    <Close sx={{ color: theme => `${theme.palette.primary.main} !important` }} />
                  }
                />
              </Tooltip>
            </Box>,
          )
        } else {
          chips.push(<Box key={`chip_item_${chips.length}`} flex={1} />)
        }
      }

      rows.push(
        <Stack key={`chips_row_${rows.length}`} direction="row" spacing={1}>
          {chips}
        </Stack>,
      )
      curStartIndex += 5
    }

    return rows
  }

  let cardContentSx = {
    paddingBottom: '0px !important',
    paddingTop: 0,
    backgroundColor: theme => alpha(theme.palette.secondary_80.main, 0.1),
  }

  if (!isFullWidth) {
    cardContentSx = {
      ...cardContentSx,
      maxWidth: 800,
      width: 800,
    }
  }

  return (
    <Card elevation={0}>
      <CardContent className={globalLess.primaryScrollbar} sx={cardContentSx}>
        <Stack direction="row" alignItems="center" justifyContent="flex-start" spacing={2} py={2}>
          <Stack flex={1} spacing={1} sx={{ overflow: 'hidden', height: 80 }}>
            {<ChipsList />}
          </Stack>

          <Stack>
            <IconButton
              disabled={page === 0}
              onClick={() => {
                onPageChange?.(page - 1)
              }}
              color="secondary_80"
            >
              <ArrowDropUp />
            </IconButton>
            <IconButton
              disabled={last}
              onClick={() => {
                onPageChange?.(page + 1)
              }}
              color="secondary_80"
            >
              <ArrowDropDown />
            </IconButton>
          </Stack>

          {!hideEdit && (
            <Button
              color="secondary_80"
              onClick={() => {
                setIsEdit(!isEdit)
              }}
            >
              {t(isEdit ? 'general.complete' : 'general.edit')}
            </Button>
          )}
        </Stack>
      </CardContent>
    </Card>
  )
}

export default LabelSelectList
